import React from 'react';
import dashboard from "../assets/icons/dashboard-icon.jpeg";
import reports from "../assets/icons/reports-icon.jpeg";
import settings from "../assets/icons/settings-icon.jpeg";
import billing from "../assets/icons/billing-icon.jpeg";
import scanner from "../assets/icons/scannerIcon.jpg";
import pos from "../assets/icons/posBilling.jpg"


const features = [
    {
        title: "Actionable Dashboard Insights",
        description: "Visualize your business performance with real-time analytics and key metrics at a glance.",
        icon: dashboard,
    },
    {
        title: "POS Billing",
        description: "Process sales quickly and efficiently with our intuitive POS billing system.",
        icon: pos,
    },
    {
        title: "Product Scanning",
        description: "Reduce errors and improve accuracy with instant product scanning.",
        icon: scanner,
    },
    {
        title: "Automated Billing Solutions",
        description: "Generate bills instantly with auto-calculated totals for a seamless checkout experience.",
        icon: billing,
    },
    {
        title: "Unlimited Report Generation",
        description: "Generate in-depth reports like sales and customer analysis effortlessly.",
        icon: reports,
    },
    {
        title: "Customizable Settings",
        description: "Tailor the platform to your business needs with flexible and intuitive settings.",
        icon: settings,
    },
];


const SummarySection = () => {

    return (
        <section className="bg-lightGray py-12" id="featuressss">
            <div className="container mx-auto">
                <h2 className="text-3xl font-bold text-primary text-center" data-aos="fade-up">Unlock Success with INVETIX</h2>
                <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="bg-white shadow-lg rounded-lg p-6 text-center"
                            data-aos="zoom-in" // Animation for each feature box
                        >
                            <img src={feature.icon} width={120} alt={feature.title} className="mx-auto" />
                            <h3 className="mt-4 font-bold text-primary">{feature.title}</h3>
                            <p className="text-gray-700 mt-2">{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SummarySection;